import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import sortBy from 'transmute/sortBy';
import { testDynamicFilterFamily, parseDynamicFilterFamilyId } from '../filterQueryFormat/DynamicFilterFamilies';
import { getCustomFieldsForAssetFamily, getTimezoneOptions, getField, getRequiredFields, getReferenceResolvers, getSpecialFieldOptions, evaluateFiltersForObject, getRefinementFieldGroups, getRefinementFields, getUnifiedEventsOptions, getIsEnabledForListMemberships } from 'customer-data-filters-ui/strategy/InboundDbListSegStrategy';
import { getObjectSegOperatorsForTypeStrict } from 'customer-data-filters-ui/converters/objectSeg/ObjectSegTypeToOperator';
import { getHasFilterFamilyAccess, getObjectAssociationOptions, fetchStandardObjectDefinitions, fetchWebVisitorSegmentEvents, getUnifiedEventsGroupOptions, fetchPropertyDataForSelectedWebVisitorsEvent, makeGetFilterFamilyTranslationKey, fetchListsMembershipObjects } from 'customer-data-filters-ui/strategy/strategyUtils';
import { CATEGORY_KEYS } from '../components/dataExplorer/categorySelection/Categories';
import { getVisibleFields } from 'customer-data-filters-ui/converters/listSegClassic/listSegFields';
import { getDefaultTimezone } from '../utils/timezoneUtils';
import { wrapSingleILSFilter, unwrapSingleILSFilter, isFieldGrouped, getFieldGroups } from 'customer-data-filters-ui/strategy/InboundDbListSegStrategyUtils';
import { deepFreeze } from '../utils/utils';
import { WebVisitors } from 'customer-data-filters-ui/filterQueryFormat/strategy/StrategyTypes';
import { validateCondition } from '../utils/conditionValidation';
import { StrategyBase } from './StrategyBase';
import { DSFilterFromObjectSeg, DSFilterToObjectSeg } from '../converters/Converters';
import { List, Map as ImmutableMap, OrderedMap } from 'immutable';
import I18n from 'I18n';
import { hasEventsForAllObjects } from '../permissions/gates';
import { makeDynamicFilterFamily } from '../filterQueryFormat/DynamicFilterFamilies';
import { isUnifiedEventObjectTypeId } from '../filterQueryFormat/ObjectTypeId';
import { getUnifiedEventName } from 'customer-data-filters-ui/strategy/filterFamilyEntityNameGetters';
import { LegacyFilterFamilyObjectNameTranslator } from 'customer-data-filters-ui/components/common/FilterFamilyTranslator';
import { getEditorFilterFamilyNameTranslation, getFilterFamilyGroupHeadingTranslation } from 'customer-data-filters-ui/utils/filterFamilyTranslationConfig';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getObjectSegFieldDefinitionsForFilterFamily } from '../converters/objectSeg/fieldDefinitions/ObjectSegFieldDefinitions';
import { getObjectSegFieldDefinitionsForFilterFamily_v2 } from '../converters/objectSeg/fieldDefinitions/ObjectSegFieldDefinitions_v2';
import { hasFieldOverrideV2, hasListMembershipObjectsUsingFrameworkAppSettings } from '../permissions/gates';
import { jsx as _jsx } from "react/jsx-runtime";
function getCustomEventOptions(props, filterFamily) {
  if (filterFamily === DSAssetFamilies.CONTACT_PROPERTY || hasEventsForAllObjects()) {
    if (getHasFilterFamilyAccess(DSAssetFamilies.UNIFIED_EVENT, props.hasScope, props.getIsUngated)) {
      return getUnifiedEventsOptions(props.data.get(DSAssetFamilies.WEB_VISITOR_SEGMENT_EVENT), props.hasScope, props.getIsUngated, filterFamily);
    }
  }
  return [];
}
function getMarketingInteractionsOptions(props, filterFamily) {
  const customEventOptions = getCustomEventOptions(props, filterFamily);
  return [...customEventOptions];
}
export function getGroupedFilterFamilyOptions(props, categoryGroupName, selectedObjectType) {
  if (testDynamicFilterFamily(DSAssetFamilies.UNIFIED_EVENT, categoryGroupName)) {
    return getUnifiedEventsGroupOptions(parseDynamicFilterFamilyId(DSAssetFamilies.UNIFIED_EVENT, categoryGroupName), props, selectedObjectType.filterFamily, DSAssetFamilies.WEB_VISITOR_SEGMENT_EVENT);
  }
  return [];
}
const makeGetFilterFamilyEntityName = ({
  data
}) => {
  return (filterFamily, __isPlural) => {
    if (isUnifiedEventObjectTypeId(filterFamily)) {
      return getUnifiedEventName(filterFamily, data.get(DSAssetFamilies.WEB_VISITOR_SEGMENT_EVENT));
    }
    return LegacyFilterFamilyObjectNameTranslator(filterFamily);
  };
};
export const getFilterFamilyName = (filterFamily, props, isSameObjectAssociation = false) => {
  const getFilterFamilyEntityName = makeGetFilterFamilyEntityName(props);
  const getFilterFamilyTranslationKey = makeGetFilterFamilyTranslationKey(props.baseFilterFamily, isSameObjectAssociation);
  const translationConfig = getEditorFilterFamilyNameTranslation(filterFamily, {
    getFilterFamilyEntityName,
    getFilterFamilyTranslationKey
  });
  if (translationConfig.key.endsWith('.undefined')) {
    return '';
  }
  return unescapedText(translationConfig.key, translationConfig.options);
};
function getAssetMembershipOptions(props, filterFamily) {
  const {
    data,
    hasScope,
    getIsUngated
  } = props;
  const dynamicFilterFamilies = OrderedMap({
    [makeDynamicFilterFamily(DSAssetFamilies.IN_LIST, filterFamily)]: getIsEnabledForListMemberships(filterFamily, data, getIsUngated) && getHasFilterFamilyAccess(DSAssetFamilies.IN_LIST, hasScope, getIsUngated)
  });
  return dynamicFilterFamilies.filter(value => value).keySeq().toArray().map(dynamicFilterFamily => ({
    value: dynamicFilterFamily,
    text: getFilterFamilyName(dynamicFilterFamily, props)
  }));
}
export const getFilterFamilyOptionsByFilterFamilyInfo = (props, filterFamilyInfo) => {
  const {
    filterFamily,
    isObjectOwnFilterBranch
  } = filterFamilyInfo;
  const options = [{
    category: CATEGORY_KEYS.PROPERTIES,
    text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.currentObject'),
    options: [{
      text: getFilterFamilyName(filterFamily, props),
      value: filterFamily,
      isAssociation: !isObjectOwnFilterBranch
    }]
  }];
  const assetMembershipOptions = getAssetMembershipOptions(props, filterFamily);
  if (assetMembershipOptions.length) {
    options.push({
      category: CATEGORY_KEYS.MEMBERSHIPS,
      text: '',
      options: assetMembershipOptions
    });
  }
  const marketingInteractionsOptions = getMarketingInteractionsOptions(props, filterFamily);
  if (marketingInteractionsOptions.length) {
    options.push({
      category: CATEGORY_KEYS.EVENTS,
      text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.marketingInteractions'),
      options: marketingInteractionsOptions
    });
  }
  return options;
};
export function getFilterFamilyOptions(props, filterFamilyInfo) {
  const options = getFilterFamilyOptionsByFilterFamilyInfo(props, filterFamilyInfo);
  return options.map(entry => Object.assign({}, entry, {
    options: sortBy(
    // @ts-expect-error sortBy has wrong type
    o => o.text.toLowerCase(), entry.options)
  }));
}
function onMount(props, requiredIdsByAssetFamily) {
  const {
    fetchMore,
    getIsUngated,
    hasScope
  } = props;
  const requests = [fetchMore({
    variables: {
      assetFamily: DSAssetFamilies.PAGE_VIEW_EVENT_PROPERTY
    }
  }), fetchPropertyDataForSelectedWebVisitorsEvent(fetchMore, requiredIdsByAssetFamily), fetchStandardObjectDefinitions(fetchMore), fetchWebVisitorSegmentEvents({
    fetchMore,
    getIsUngated,
    hasScope
  })];
  return Promise.all(requests);
}
function onEditorMount(props, requiredIdsByAssetFamily) {
  const {
    fetchMore,
    getIsUngated,
    hasScope
  } = props;
  const fetches = [fetchMore({
    variables: {
      assetFamily: DSAssetFamilies.PAGE_VIEW_EVENT_PROPERTY
    }
  }), fetchPropertyDataForSelectedWebVisitorsEvent(fetchMore, requiredIdsByAssetFamily, true), fetchStandardObjectDefinitions(fetchMore), fetchWebVisitorSegmentEvents({
    fetchMore,
    getIsUngated,
    hasScope
  })];
  if (hasListMembershipObjectsUsingFrameworkAppSettings()) {
    fetches.push(fetchListsMembershipObjects(fetchMore));
  }
  return Promise.all(fetches);
}
function getOperatorsForType(type, filterFamily, isUngated, options) {
  return getObjectSegOperatorsForTypeStrict(type, filterFamily, isUngated, options);
}
function getWebVisitorsField(filterFamily, id, defaultField, props) {
  var _props$data;
  // for page view event properties, check in PAGE_VIEW_EVENT_PROPERTY
  const eventProperties = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.get(DSAssetFamilies.PAGE_VIEW_EVENT_PROPERTY);
  if (eventProperties) {
    const property = eventProperties.get(id);
    if (property) {
      return property;
    }
  }

  // for unified event properties, check in WEB_VISITORS_EVENT-eventID
  if (isUnifiedEventObjectTypeId(filterFamily)) {
    var _props$data2;
    const unifiedEventCacheKey = makeDynamicFilterFamily(DSAssetFamilies.WEB_VISITORS_EVENT, filterFamily);
    const unifiedEventProperties = (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.get(unifiedEventCacheKey);
    if (unifiedEventProperties) {
      const property = unifiedEventProperties.get(id);
      if (property) {
        return property;
      }
    }
  }

  // for Contact properties, check in "0-1"
  return getField(filterFamily, id, defaultField, props);
}
function getWebVisitorsFieldGroups(assetFamily, props) {
  var _props$data3;
  const fieldGroups = getFieldGroups(assetFamily, props);
  const eventProperties = (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.get(DSAssetFamilies.PAGE_VIEW_EVENT_PROPERTY);
  const ALLOWED_FIELDS = [];
  const PAGE_VISIT_PROPERTIES_ALLOWLIST = ['hs_enrichment_company_size', 'hs_enrichment_company_industry', 'hs_enrichment_company_revenue', 'hs_enrichment_company_technologies', 'hs_country', 'hs_region', 'hs_city', 'hs_is_contact', 'hs_language', 'hs_is_new_cookie', 'hs_utm_content', 'hs_utm_term', 'hs_utm_campaign', 'hs_utm_source', 'hs_utm_medium', 'hs_visit_source', 'hs_referrer', 'hs_device_type'];
  if (!fieldGroups || fieldGroups.size === 0) {
    return fieldGroups;
  }
  const filteredGroups = fieldGroups.map(group => {
    if (!group.properties) {
      return group;
    }
    const filteredProperties = group.properties.filter(property => ALLOWED_FIELDS.includes(property.name));
    if (filteredProperties.size === 0) {
      return null;
    }
    return group.set('properties', filteredProperties);
  }).filter(Boolean);
  if (eventProperties && eventProperties.size > 0) {
    const filteredEventProperties = eventProperties.filter(property => PAGE_VISIT_PROPERTIES_ALLOWLIST.includes(property.name));
    if (filteredEventProperties.size > 0) {
      const groupsMap = new Map();
      filteredEventProperties.forEach(property => {
        if (!property.groupName) {
          return;
        }
        const groupName = property.groupName;
        const displayName = property.groupDisplayName || property.groupName;
        const displayOrder = property.groupDisplayOrder || 0;
        if (!groupsMap.has(groupName)) {
          groupsMap.set(groupName, {
            displayName,
            displayOrder,
            properties: []
          });
        }
        groupsMap.get(groupName).properties.push(property);
      });

      // Convert to PropertyGroupRecord format
      const propertyGroups = ImmutableMap().withMutations(mutableMap => {
        groupsMap.forEach((groupData, groupName) => {
          mutableMap.set(groupName, PropertyGroupRecord({
            displayOrder: groupData.displayOrder,
            displayName: groupData.displayName,
            name: groupName,
            properties: List(groupData.properties)
          }));
        });
      });
      return filteredGroups.merge(propertyGroups);
    }
  }
  return filteredGroups;
}
const serializer = {
  fromFormat: DSFilterFromObjectSeg,
  toFormat: DSFilterToObjectSeg
};
export class WebVisitorsStrategy extends StrategyBase {
  configure(customConfig) {
    const newStrategy = new WebVisitorsStrategy(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
}
export const getFields = (assetFamily, props) => {
  if (!assetFamily || isFieldGrouped(assetFamily)) {
    return undefined;
  }
  const {
    data,
    hasScope
  } = props;
  const cacheKey = isUnifiedEventObjectTypeId(assetFamily) ? makeDynamicFilterFamily(DSAssetFamilies.WEB_VISITORS_EVENT, assetFamily) : assetFamily;
  const fields = data.get(cacheKey);
  const scopes = {
    'crm-views-all': hasScope('crm-views-all')
  };
  const visibleFields = getVisibleFields(fields, assetFamily, scopes);
  if (visibleFields && visibleFields.size === 0 && fields && fields.size > 0) {
    return undefined;
  }
  return visibleFields;
};
export const getFilterFamilyGroupHeading = (filterFamily, associationId, isEditor, props, isSameObjectAssociation = false) => {
  const getFilterFamilyEntityName = makeGetFilterFamilyEntityName(props);
  const getFilterFamilyTranslationKey = makeGetFilterFamilyTranslationKey(props.baseFilterFamily, isSameObjectAssociation, associationId, props.data);
  const translationConfig = getFilterFamilyGroupHeadingTranslation(filterFamily, {
    getFilterFamilyEntityName,
    getFilterFamilyTranslationKey,
    isEditor
  });
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: translationConfig.key,
    options: translationConfig.options
  });
};
export const getFilterFamilyObjectName = (filterFamily, isPlural, data) => {
  const getEntityName = makeGetFilterFamilyEntityName({
    data
  });
  return getEntityName(filterFamily, isPlural);
};
export const getFieldDefinitions = (filterFamily, isUngated) => {
  if (!filterFamily) {
    return undefined;
  }
  const cacheKey = isUnifiedEventObjectTypeId(filterFamily) ? makeDynamicFilterFamily(DSAssetFamilies.WEB_VISITORS_EVENT, filterFamily) : filterFamily;
  return isUngated && hasFieldOverrideV2(isUngated) ? getObjectSegFieldDefinitionsForFilterFamily_v2(cacheKey) : getObjectSegFieldDefinitionsForFilterFamily(cacheKey);
};
export const WebVisitorsStrategyInstance = deepFreeze(new WebVisitorsStrategy({
  onMount,
  onEditorMount,
  getCustomFieldsForAssetFamily,
  getDefaultTimezone,
  getTimezoneOptions,
  getField: getWebVisitorsField,
  getFieldDefinitions,
  getFieldGroups: getWebVisitorsFieldGroups,
  getRefinementFieldGroups,
  getRefinementFields,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(assetFamily: $tsMigrateAny, props: $tsMigra... Remove this comment to see the full error message
  getFields,
  getRequiredFields,
  getFilterFamilyOptions,
  getGroupedFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyGroupHeading,
  getFilterFamilyObjectName,
  getIsFiscalYearEnabled: () => false,
  getOperatorsForType,
  getReferenceResolvers,
  getSpecialFieldOptions,
  getObjectAssociationOptions,
  serializer,
  wrapSingleFilter: wrapSingleILSFilter,
  unwrapSingleFilter: unwrapSingleILSFilter,
  strategyType: WebVisitors,
  validateOperator: validateCondition,
  isIncludeObjectsWithNoValueSetCheckboxEnabled: true,
  getHasFilterFamilyAccess,
  evaluateFiltersForObject,
  isNotCompletedUnifiedEventFiltersEnabled: true,
  isSameObjectAssociationFilteringEnabled: true,
  canEditLogicGroupCondition: true,
  isTestFiltersEnabled: false
}));